import { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export interface ConversationMessage {
    role: "User" | "Assistant";
    content: string;
    responseId?: string;
    isComplete?: boolean;
    timestamp: string;
}

export function ConversationModal({ messages }: { messages: ConversationMessage[] }) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (containerRef.current) {
                containerRef.current.scrollTo({
                    top: containerRef.current.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    }, [messages]);

    return (
        <div ref={containerRef} className="conversation-container">
            {messages.map((msg, index) => {
                const isUser = msg.role === "User";
                const isIncomplete = msg.isComplete === false;

                // Decide the static background image for completed messages
                const iconStyle = {
                    backgroundImage: isUser
                        ? 'url("https://cdn-icons-png.freepik.com/256/18458/18458155.png")'
                        : 'url("https://cdn-icons-png.freepik.com/256/10177/10177473.png")'
                };

                return (
                    <div key={index} className={`msg ${isUser ? "right-msg" : "left-msg"}`}>
                        <div className="msg-img">
                            {isIncomplete ? (
                                isUser ? (
                                    <div className="mic-pulse-animation" />
                                ) : (
                                    <div className="assistant-wave-animation">
                                        <div className="wave-bar" />
                                        <div className="wave-bar" />
                                        <div className="wave-bar" />
                                    </div>
                                )
                            ) : (
                                <div style={iconStyle} className="msg-img-static" />
                            )}
                        </div>

                        <div className={`msg-bubble ${isUser ? "right-background" : "left-background"}`}>
                            <div className="msg-info">
                                <div className="msg-info-name">{msg.role}</div>
                                {/* <div className="msg-info-time">
                                    {new Date(msg.timestamp).toLocaleTimeString([], {
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true
                                    })}
                                </div> */}
                            </div>
                            <div className="msg-text">
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.content}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
